module.exports = __webpack_public_path__ + "img/night-snow.8fd20db0.svg";